import { LitElement } from 'lit';
import { unsafeStatic, html } from "lit/static-html.js";
import { i18n } from '@lingui/core';
import { messages as nbMessages} from '../src/raw/twitter/locales/nb/messages.mjs';
import { messages as enMessages} from '../src/raw/twitter/locales/en/messages.mjs';
import { messages as fiMessages} from '../src/raw/twitter/locales/fi/messages.mjs';
import { messages as daMessages} from '../src/raw/twitter/locales/da/messages.mjs';
import { activateI18n } from '../src/utils/i18n';
activateI18n(enMessages, nbMessages, fiMessages, daMessages);


export class IconTwitter24 extends LitElement {
  render() {
      const title = i18n.t({ message: `Twitter logo`, id: 'icon.title.twitter', comment: 'Title for Twitter icon' });
      
      return html`<svg xmlns="http://www.w3.org/2000/svg"width="24"height="24"fill="none"viewBox="0 0 24 24" part="w-icon-twitter-24-part">${unsafeStatic(`<title>${title}</title>`)}<path fill="currentColor" d="M13.903 10.469 21.348 2h-1.764l-6.465 7.353L7.955 2H2l7.808 11.12L2 22h1.764l6.828-7.765L16.044 22H22l-8.098-11.531Zm-2.417 2.748-.791-1.107L4.4 3.3h2.71l5.08 7.11.791 1.107 6.604 9.242h-2.71z"></path></svg>`; }
}
if (!customElements.get('w-icon-twitter-24')) {
  customElements.define('w-icon-twitter-24', IconTwitter24);
}